module.exports = __webpack_public_path__ + "jpmChase.38eed7ded5f72a9daecb8ec4b2111baa.svg";